import { Component, inject, OnDestroy } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { ActivatedRoute, Params } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { ErzeugungsanlageDetailComponent } from '../erzeugungsanlage-detail/erzeugungsanlage-detail.component';
import { PlanwertDetailComponent } from '../../planwert/planwert-detail/planwert-detail.component';

@Component({
    selector: 'redispatch-erzeugungsanlage-page',
    templateUrl: './erzeugungsanlage-page.component.html',
    styleUrls: [
        './erzeugungsanlage-page.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlagePageComponent implements OnDestroy {

    private componentDestroyed = false;

    private westnetzSidenavService = inject(WestnetzSidenavService);
    private activateRoute = inject(ActivatedRoute);

    constructor() {

        this.activateRoute.queryParams
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(params => {
                if (!params) {
                    return;
                }

                if (this.isPlanwertCreate(params)) {
                    this.westnetzSidenavService.openRightnav(PlanwertDetailComponent);
                } else if (this.isErzeugungsanlageEdit(params) || this.isErzeugungsanlageCreate(params)) {
                    this.westnetzSidenavService.openRightnav(ErzeugungsanlageDetailComponent);
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    private isPlanwertCreate(params: Params): boolean {
        return params.erzeugungsanlage && (params.createnewplannedvalue === true || params.createnewplannedvalue === 'true');
    }

    private isErzeugungsanlageEdit(params: Params): boolean {
        return params.erzeugungsanlage;
    }

    private isErzeugungsanlageCreate(params: Params): boolean {
        return params.createnew === true || params.createnew === 'true';
    }

}

